// extracted by mini-css-extract-plugin
export default {"background_image":"about_background_image__-NpqB","background_color":"about_background_color__tKHzC"};